import { Component, IterableDiffer } from "@angular/core";
import { timer } from "rxjs";
import { ActionSheetController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { ModalController } from "@ionic/angular";
import { ScoreBoardBib } from "../scoreboard-bib/scoreboard-bib";

import { IterableDiffers, DoCheck } from '@angular/core';

@Component({
    selector: 'race-by-bib',
    templateUrl: 'race-by-bib.html',
    styleUrls:['./race-by-bib.scss']
})

export class RaceByBib {
    athleteTimer: number = 0;
    interval;
    stopWatch = null;
    timerStarted: boolean = false;
    athletes: any = [];
    athletePlace = 0;
    selectedAth;
    differ: any;
    colorIcon:any;
    bgColor:any;
    color:any;

    constructor(private actionSheetCtrl: ActionSheetController,
                private translate: TranslateService, 
                private modalCtrl: ModalController,
                differs: IterableDiffers) {
                  this.differ = differs.find([]).create(null);
    }
transform(value: number){
  let time =  new Date(value * 1000).toISOString().substr(11,10);
  return time
}

ngDoCheck() {
  const change = this.differ.diff(this.athletes);
  
  this.sortArray();
  console.log("change");
  
}

sortArray(){
  let arr;

  arr = this.athletes.sort((a, b) => a.time > b.time && 1 || -1);
  for(let i = 0; i < arr.length; i++){
      arr[i].place = 0;
  }

  for(let i = 0; i < arr.length; i++){
      arr[i].place = i + 1;
  }

  console.log("arr sorted" + JSON.stringify(arr));
  
  this.athletes = arr;
}

  startTimer() {
    if(!this.stopWatch){
        this.timerStarted = true;
        this.stopWatch = timer(0,100).subscribe(() => {
        this.athleteTimer += 0.1;
        // console.log("athlete timer " + this.athleteTimer);
        });
    }
  }

  pauseTimer() {
      if(this.stopWatch){
        this.stopWatch.unsubscribe();
        this.stopWatch = null;
        this.timerStarted = false;
      } clearInterval(this.interval);
  }

  async restartTimer() {
    let actionSheet = await this.actionSheetCtrl.create({
        header: this.translate.instant('RESTART_ROUND'),
        buttons: [
            {
                text: this.translate.instant('GLOBAL_YES'),
                handler: () => {
                    if(this.stopWatch){
                        this.stopWatch.unsubscribe();
                        this.stopWatch = null;
                        this.timerStarted = false;
                        this.athleteTimer = 0;
                        this.athletes.length = 0;
                        this.athletePlace = 0;
                      }
                      else{
                        this.timerStarted = false;
                        this.athleteTimer = 0;
                        this.athletes.length = 0;
                        this.athletePlace = 0;
                      }
                }
            }, 
            {
                text: this.translate.instant('GLOBAL_NO'),
            }
        ]
    });
    actionSheet.present();
  }

  displayTimer() {
    return this.transform(this.athleteTimer);
  }

  recordAthTime() {
    if(this.timerStarted){
      let index = this.athletes.findIndex(i => i.isSelected == true);
      if(index == -1){
        this.athletePlace++;

        let athlete = {
          time: this.transform(this.athleteTimer), 
          place: this.athletePlace,
          isSelected: true,
          bibNo:"",
          name: ""
        }
        this.athletes.push(athlete);
        this.selectedAth = this.athletes[0];
      }

      else if(index == 0){
        this.athletePlace++;

        let athlete = {
          time: this.transform(this.athleteTimer), 
          place: this.athletePlace,
          isSelected: true,
          bibNo: "",
          name: ""
        }
        this.athletes.push(athlete);

        this.athletes[index].isSelected = false;
        this.selectedAth = this.athletes[index + 1];
      }

      else if(index == this.athletes.length - 1 && this.athletes.length != 0){
        this.athletePlace++;

        let athlete = {
          time: this.transform(this.athleteTimer), 
          place: this.athletePlace,
          isSelected: true,
          bibNo: "",
          name: ""
        }

        this.athletes.push(athlete);
        this.athletes[index].isSelected = false;
        this.selectedAth = this.athletes[index + 1];
      }
      else{
        this.athletes[index].isSelected = false;
        this.athletes[index + 1].isSelected = true;
        this.selectedAth = this.athletes[index + 1];
      }
    }
  }
  
  enterNumber(n: number){
    if(this.selectedAth.bibNo.length > 4){
      this.selectedAth.bibNo += n + "";
      this.deleteBibNumber();
    }
    else{
        this.selectedAth.bibNo += n + "";
    }
  }

  enterBibNumber(athlete){
    for(let i = 0; i < this.athletes.length; i++){
        this.athletes[i].isSelected = false;
    }

    if(athlete.isSelected){
        athlete.isSelected = false;
    }
    else{
        athlete.isSelected = true;
    }
    
    this.selectedAth = athlete;
  }

  deleteBibNumber(){
    // this.selectedAth.bibNo.substring(0, this.selectedAth.bibNo.length - 1);
    let string = this.selectedAth.bibNo.slice(0, -1);
    this.selectedAth.bibNo = string;
    console.log("selected ath" + JSON.stringify(this.selectedAth));
  }

  enterNumPud() {
    let index = this.athletes.findIndex(i => i.isSelected == true);
    console.log("index " + index);

    if(index == 0 && this.athletes.length == 1){
      this.recordAthTime();
      this.athletes[index].isSelected = false;
      this.athletes[index + 1].isSelected = true;
      this.selectedAth = this.athletes[index + 1];
      console.log("athletes " + JSON.stringify(this.athletes));
    }
    else if(index == 0 && this.athletes.length > 1){
      // this.recordAthTime();
      this.athletes[index].isSelected = false;
      this.athletes[index + 1].isSelected = true;
      this.selectedAth = this.athletes[index + 1];
    }
    else if(index == this.athletes.length - 1 && this.athletes.length != 0){
      this.recordAthTime();
      this.athletes[index].isSelected = false;
      this.athletes[index + 1].isSelected = true;
      this.selectedAth = this.athletes[index + 1];
      console.log("athletes length" + this.athletes.length);
    }
    else if(index == -1 && this.timerStarted){
      this.recordAthTime();
      this.athletes[index + 1].isSelected = true;
      this.selectedAth = this.athletes[index + 1];
    }
    else{
      this.athletes[index].isSelected = false;
      this.athletes[index + 1].isSelected = true;
      this.selectedAth = this.athletes[index + 1];
    }
  }

  openScoreBoardBib() {
    this.modalCtrl.create({component:ScoreBoardBib, componentProps:{arr: this.athletes}}).then(modal=>modal.present());
  }
 
}
